<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="pt1"> </p>
<p class="PN"><span class="ePub-B">PART I</span></p>
<p class="PT">THE VETERANS OF A THOUSAND PSYCHIC WARS</p>
<p class="PEP"><span class="ePub-I">And he was bent on making us feel as he did, and of course his magic accomplished his desire.</span></p>
<p class="PEPC">—Mark Twain</p>
<p class="PEP"><span class="ePub-I">your magic errandboy’s<br/>just made a bad guess again</span></p>
<p class="PEPC">—Allen Ginsberg</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?896a8442